import {AD_GOALS} from './adGoals';
import {trackVkGoal, trackVkPageView} from './vkPixel';
import {trackYandexGoal, trackYandexPageView} from './yandexMetrika';

/**
 * Единая точка отправки рекламной аналитики: пиксель VK Рекламы и Яндекс
 * Метрика получают одно и то же событие.
 *
 * Экраны и игровые действия зовут ТОЛЬКО этот фасад, а не счетчики напрямую:
 * иначе при добавлении третьей системы (или при добавлении новой цели)
 * пришлось бы обойти два десятка мест и где-нибудь одно да забылось бы —
 * а расхождение между кабинетами обнаруживается не сразу и портит
 * обучение автостратегий.
 *
 * Каждый счетчик сам решает, молчать ли ему: оба выключены вне продакшена и
 * оба переживают отсутствие своей библиотеки (блокировщики рекламы срезают
 * их регулярно), поэтому падение одного не мешает другому.
 */

export {AD_GOALS};

/**
 * Виртуальный просмотр экрана.
 * @param {string} pageId - идентификатор экрана (см. usePageAnalytics)
 * @param {string} [userId] - id игрока
 */
export const trackAdPageView = (pageId, userId) => {
  trackVkPageView(pageId, userId);
  trackYandexPageView(pageId, userId);
};

/**
 * Целевое событие.
 * @param {string} goal - имя цели из AD_GOALS
 * @param {Object} [options] - {userId, value, params}
 */
export const trackAdGoal = (goal, options) => {
  trackVkGoal(goal, options);
  trackYandexGoal(goal, options);
};
